import { isTablet } from 'react-device-detect';
import { isMobileDevice } from '../../../../util/deviceDetection';
import {
  getDesktopTools2D,
  getDesktopTools3D,
  getDesktopToolsECG,
  getMobileTools2D,
  getMobileTools3D,
  getMobileToolsECG,
  groupedTools as groupedToolsConfig,
  rotationTools as rotationToolsConfig,
  zoomTools as zoomToolsConfig,
} from './toolsDisplayConfig';
import { toolsConfig } from './toolsConfig';
import toolNames from './toolNames';
import { enabledToolbarItems } from '../../../../util/ToolbarUtils';

export const TYPE_TOOLSET_2D = 'toolset2D';
export const TYPE_TOOLSET_3D = 'toolset3D';
export const TYPE_TOOLSET_ECG = 'toolsetECG';

const hideTabletCaptureTools = (tools) => (
  isTablet ? tools.filter((toolName) => toolName !== toolNames.SCREENSHOT) : tools
);

export const filterToolsetByNameList = (toolset, orderedToolNames) => toolset
  .filter((tool) => orderedToolNames.includes(tool.name));

export const orderToolsetByNameList = (toolset, orderedToolNames) => toolset
  .sort((tool) => orderedToolNames.includes(tool.name));

export const filterAndOrderToolsByNamesList = (toolset, orderedToolNames) => {
  if (orderedToolNames.length === 0) return toolset;

  return enabledToolbarItems(orderedToolNames.map((toolName) => toolset
    .find((tool) => tool.name === toolName)));
};

export const getOrderedToolNamesByDevice = (toolsetType) => {

  let orderedToolNames = [];

  switch (toolsetType) {
    case TYPE_TOOLSET_2D:
      if (isMobileDevice()) {
        orderedToolNames = getMobileTools2D();
      } else {
        orderedToolNames = hideTabletCaptureTools(getDesktopTools2D());
      }
      break;

    case TYPE_TOOLSET_3D:
      if (isMobileDevice()) {
        orderedToolNames = getMobileTools3D();
      } else {
        orderedToolNames = hideTabletCaptureTools(getDesktopTools3D());
      }
      break;

    case TYPE_TOOLSET_ECG:
    default:
      if (isMobileDevice()) {
        orderedToolNames = getMobileToolsECG();
      } else {
        orderedToolNames = hideTabletCaptureTools(getDesktopToolsECG());
      }
      break;
  }

  return orderedToolNames;
};

export const loadGroupedTools = () => {
  const groupedTool = toolsConfig.find((tool) => tool.name === toolNames.GROUPED_TOOLS);
  groupedTool.groupedTools = enabledToolbarItems(groupedToolsConfig
    .map((toolName) => toolsConfig.find((tool) => tool.name === toolName))
    .filter(Boolean)
    .filter((tool) => !(isMobileDevice() && tool.name === toolNames.REF_LINES)));
  return groupedTool;
};

export const loadRotationTools = () => {
  const rotationTool = toolsConfig.find((tool) => tool.name === toolNames.ROTATE_MENU);
  rotationTool.groupedTools = enabledToolbarItems(rotationToolsConfig
    .map((toolName) => toolsConfig.find((tool) => tool.name === toolName))
    .filter(Boolean)
    .map((tool) => (tool.name === toolNames.ROTATE ? { ...tool, label: 'Rotate' } : tool)));
  return rotationTool;
};

export const loadZoomTools = () => {
  const zoomTool = toolsConfig.find((tool) => tool.name === toolNames.ZOOM_MENU);
  zoomTool.options = zoomToolsConfig
    .map((toolName) => toolsConfig.find((tool) => tool.name === toolName))
    .filter(Boolean)
    .map(({ name, label, icon }) => ({ name, label, icon }));
  return zoomTool;
};
